<template>
  <div class="upload">
    <div
      v-show="isSHowApprove"
      class="approve-wrapper"
    />
    <el-tooltip
      class="item"
      effect="dark"
      :content="$t('当前文件夹无此权限')"
      :disabled="!isUploadDisable"
    >
      <span
        v-show="isShowHeader"
        id="isUploadBtn"
        class="lv-btn default-btn"
        :class="{'disabled': isUploadDisable}"
        @click="todo"
      >{{ $t('上传') }}</span>
    </el-tooltip>
    <input
      id="upload-button"
      ref="uploadit"
      type="file"
      multiple
      size="1"
      style="display: none"
      @change="getAuth($event)"
    >
    <uploadDialog
      v-if="showUploadEL"
      ref="uploadDialog"
      :upload-info.sync="uploadInfo"
      :file-index.sync="fileIndex"
      :total-size.sync="totalSize"
      :is-approve.sync="isApprove"
      @confirmAction="confirmAction"
      @cancelUpload="cancelUpload"
      @submitApprove="submitApprove"
      @closeUploadEL="closeUploadEL"
    />
    <confirm
      :visible="showApprove"
      class="approve-tips"
      :title="$t('提示')"
      :single-button="true"
      :confirm-button="$t('继续')"
      :content="content"
      :action-type="trashErrorType"
      :dialog-size="dialogSize"
      @confirm="confirmAction"
      @close="closeApprove"
    >
      <template slot="remember">
        <div class="content-wraper">
          <p class="dialogUploadTips">
            {{ $t('该目录上传文件需经过审批后生效') }}
          </p>
          <ul class="uploadTipsUl">
            <li>
              <p class="uploadTipsNum">
                1
              </p>
              <p class="uploadTipsTxt">
                {{ $t('文件传输成功') }}
              </p>
            </li>
            <li>
              <span class="uploadTipsPoint" />
            </li>
            <li>
              <p class="uploadTipsNum">
                2
              </p>
              <p class="uploadTipsTxt">
                {{ $t('提交审批') }}
              </p>
            </li>
            <li>
              <span class="uploadTipsPoint" />
            </li>
            <li>
              <p class="uploadTipsNum">
                3
              </p>
              <p class="uploadTipsTxt">
                {{ $t('审批通过，文件在目录中显示') }}
              </p>
            </li>
          </ul>
          <el-checkbox
            v-model="noremind"
            class="cleaning-switch"
          >
            {{ $t('不再提示') }}
          </el-checkbox>
        </div>
      </template>
    </confirm>
  </div>
</template>
<script>
import { getAuthToken } from 'components/business/link/auth/fiveMinAuth.js'
import uploadDialog from 'components/business/link/privateupload/upload-dialog.vue'
import { approveMask } from 'js/api/privateApi/private-apis'
import confirm from 'components/common/confirm/index.vue'
import { MessageBox } from 'element-ui'
import store from 'store'
import * as Util from 'js/util/util'
// import Bus from 'js/mixin/bus'
import Vue from 'vue'

const { getData, postData, upload } = require('js/api/getdata').default
const Cookie = require('js/lib/cookie')

export default {
  name: 'Upload',
  components: {
    uploadDialog,
    confirm,
  },
  props: {
    folderDcType: Number,
    isShowHeader: Boolean,
    isProtected: Boolean,
    isUploadDisable: {
      type: Boolean,
      default: false,
    },
    currentData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showConfirm: false,
      content: '',
      noremind: false,
      canRefresh: true,
      /* 这是配置参数 */
      param: {
        'X-LENOVO-SESS-ID': Cookie.get('X-LENOVO-SESS-ID'),
        overwrite: true,
        source: 'link',
        language: Cookie.get('language') || 'zh',
        t: new Date().getTime(),
        path_type: '',
        prefix_neid: '',
        from: '',
        utime: new Date().getTime(),
        hash: this.currentData.delivery_code,
      },
      isSHowApprove: false,
      // path: localStorage.getItem("currentPath"),
      progressInfo: [],
      dataId: 0, // 上传列表文件数据索引
      showUploadEL: false,
      uploadInfo: [],
      axiosList: [],
      fileList: [],
      tempFileList: [],
      fileListLen: 0,
      fileIndex: 0,
      lockList: [],
      warnTxt: [],
      totalSize: 0,
      toCloseUploadEl: false,
      // originPath: '',
      subContent: '',
      title: '',
      confirmButton: '',
      cancelButton: '',
      trashErrorType: '',
      confirmIcontype: 'warn',
      trashActionType: '',
      dataIndex: 0,
      dialogSize: '',
      showApprove: false,
      isApprove: false,
      approvefrom: '',
      neid: '',
      taskId: '',
      prefix_neid: '',
      approvePath: '',
      isInitaiateApprove: false,
    }
  },
  computed: {
    pathType() {
      const { $route } = this
      return $route.meta.path_type || $route.name
    },
    uid() {
      return store.getters.uId
    },
    accountId() {
      return store.getters.accountId
    },
    path() {
      return this.currentData.path
    },
    originPath() {
      const arr = this.currentData.path.split('/')
      if (arr.length > 2) {
        arr.shift()
        arr.shift()
        return `/${this.currentData.delivery_code}/${arr.join('/')}`
      }
      return `/${this.currentData.delivery_code}`
    },
    prefixNeid() {
      return this.currentData.prefix_neid
    },
    customize() {
      return store.state.lenovoData.customize
    },
    fileNum() {
      let num = 0
      const status = this.uploadInfo[0]
      if (this.uploadInfo[0] === undefined) return 0
      for (let i = 0; i < status.length; i += 1) {
        if (status[i].status !== 'FAILED' && status[i].status !== 'CANCELED') {
          num += 1
        }
      }
      return num
    },
    getEntName() {
      return Util.getLanguage() === 'en'
        ? store.getters.custominfo.custom_company_space_en_name
        : store.getters.custominfo.custom_company_space_zh_name
    },
  },
  watch: {
    path() {
      // getData('isExistPolicy', {
      //   nsid: this.nsid || 1,
      //   path: encodeURIComponent(this.currentData.path),
      // }).then((res) => {
      //   const item = res.data.content && res.data.content[0]
      //   const pMask = item && item.pdm
      //   const parseData = Util.approveMask(pMask)
      //   const resData = parseData.prop
      //   this.isApprove = resData.upload
      // })
    },
    dataId(val) {
      const scroll = document.getElementsByClassName('upload-scroll-wrapper')[0]
      if (scroll === undefined) return
      if (scroll && val > 5) {
        scroll.scrollTop = (val - 5) * 51
      } else {
        scroll.scrollTop = 0
      }
    },
  },
  mounted() {
    // Bus.$on('initiateApprove', (data) => {
    //   this.initiateApprove(data)
    // })
    Vue.prototype.$dragUplaod = this.dndUpload.bind(this)
    const vm = this
    window.onbeforeunload = function (event) {
      const e = event || window.event
      if (this.uploadListStatus() === false) {
        if (e) {
          e.returnValue = vm.$t('上传正在进行中，是否离开当前页？')
        }
        return vm.$t('上传正在进行中，是否离开当前页？')
      }
    }
  },
  methods: {
    async uploadApproveInfo(params) {
      // 我的审批中接入数据，并对数据进行整理
      this.isApprove = true
      this.isSHowApprove = true
      this.showUploadEL = true
      this.uploadInfo[0] = []
      this.param.path_type = 'ent'
      this.approvePath = params.path
      this.prefix_neid = params.neid
      this.approvefrom = params.from
      this.neid = params.neid
      this.taskId = params.taskId
      this.param.from = params.from
      this.param.prefix_neid = params.neid
      // this.param.path = params.path;
      this.fileListLen = params.content.length
      this.dataId = params.content.length
      const progress = {
        isTrusted: true,
        lengthComputable: true,
        loaded: 1048760,
        total: 1048760,
        type: 'progress',
        eventPhase: 0,
        bubbles: false,
        cancelable: false,
        defaultPrevented: false,
        composed: false,
        cancelBubble: false,
      }
      for (const item of params.content) {
        const file = {
          name: item.path.split('/').pop(),
          lastModified: item.modified,
          webkitRelativePath: '',
          size: item.size,
          type: item.mime_type,
        }
        const remaining = {
          speed: 0,
          loaded: item.size,
        }
        const o = {
          file,
          path: `/企业空间${this.approvePath}`,
          neid: this.param.neid,
          path_type: 'ent',
          progressEvent: progress,
          status: 'SUCCESSED',
          remaining,
        }
        this.fileList.push(o)
        this.uploadInfo[0] = this.fileList
        const timer = setTimeout(() => {
          this.cancelUpload('all')
          this.$refs.uploadDialog.hasCancel = true
          clearTimeout(timer)
        }, 300)
      }
    },
    async initiateApprove(params) {
      // 我的审批中接入数据，并对数据进行整理
      this.isApprove = true
      this.uploadInfo[0] = []
      this.param.path_type = 'ent'
      this.approvePath = params.path
      this.prefix_neid = params.neid
      this.approvefrom = params.from
      this.neid = params.neid
      this.taskId = ''
      this.param.from = params.from
      this.param.prefix_neid = params.neid
      this.param.path = params.path
      this.isApprove = true
      // 发起审批如果勾选了不再提示显示弹窗
      if (localStorage.getItem('noremind') === 'true') {
        this.$refs.uploadit.click()
      } else {
        this.showApprove = true
        this.isSHowApprove = true
      }
      this.isInitaiateApprove = true
      if (this.showUploadEL) {
        this.closeUploadEL()
      }
    },
    // 重置上传组件数据
    clearData() {
      this.progressInfo = []
      this.dataId = 0 // 上传列表文件数据索引
      this.uploadInfo = []
      this.axiosList = []
      this.fileList = []
      this.fileListLen = 0
      this.fileIndex = 0
      this.lockList = []
      this.warnTxt = []
      this.totalSize = 0
      this.dataIndex = 0
      this.approvefrom = ''
      this.neid = ''
      this.taskId = ''
      this.prefix_neid = ''
      this.isInitaiateApprove = false
      this.clearFileInput()
    },
    // 提交上传审批
    submitApprove() {
      let path = ''
      if (this.isInitaiateApprove) {
        path = store.state.selectedData.data[0].data.path
      } else {
        path = this.path
      }
      if (this.$route.name === 'myapproval') {
        this.$emit('submitApprove')
      } else {
        Bus.$emit('getTarget', { name: 'reqApproval', operateType: '1' },
          {
            neids: this.currentData.neid,
            nsid: this.currentData.nsid,
            taskId: this.taskId,
            path,
            type: 'upload',
          })
      }
    },
    async todo() {
      // this.isExistPolicy()
      if (this.isUploadDisable) return
      // 点击上传获取是否有上传审批
      this.$refs.uploadit.click()
      // const timer = setTimeout(() => {
      //   clearTimeout(timer)
      //   if (this.isApprove) {
      //     this.isApprove = true
      //     if (this.showUploadEL) {
      //       this.closeUploadEL()
      //     }
      //     if (localStorage.getItem('noremind') === 'true') {
      //       this.$refs.uploadit.click()
      //     } else {
      //       this.showApprove = true
      //     }
      //   } else {
      //     this.$refs.uploadit.click()
      //   }
      // }, 300)
    },
    confirmAction() {
      if (this.noremind) {
        localStorage.setItem('noremind', 'true')
      }
      this.$refs.uploadit.click()
    },
    closeApprove() {
      this.showApprove = false
      this.isSHowApprove = false
    },
    closeConfirm() {
      this.showConfirm = false
      if (this.toCloseUploadEl) {
        this.cancelUpload('all')
        this.toCloseUploadEl = false
        this.showUploadEL = false
        this.isSHowApprove = false
        this.axiosList = []
        this.uploadInfo = []
        // this.fileList = [];
        // this.lockList = [];
      }
    },
    /**
       * 上传前数据校验
       */
    async getAuth(e) {
      if (e.target.files.length === 0) return
      if (e.target.files.length > 1000) {
        this.$emit('showTips', this.$t('对不起，一次最多只能添加1000个文件！'))
        return
      }
      if (this.isApprove && (this.fileNum + e.target.files.length > 200)) {
        this.$emit('showTips', this.$t('一次审批允许200个文件'))
        return
      }
      this.showApprove = false
      const browser = navigator.appName
      const bVersion = navigator.appVersion
      const version = bVersion.split(';')
      const trimVersion = version[1] ? version[1].replace(/[ ]/g, '') : ''

      if (browser === 'Microsoft Internet Explorer' && trimVersion === 'MSIE9.0') {
        this.$emit('showTips', `${this.$t('当前浏览器上传成功率较低，请')} <a style='color:#2285ff' id='editOutSide' href='https://bestvpn.org/outdatedbrowser/en' target='_blank'>${this.$t('升级浏览器')}</a>`, 'notAutoClose')
        return
      }

      this.$nextTick(() => { // 上传弹窗最大化
        if (this.isApprove) {
          this.isSHowApprove = true
        }
        this.showUploadEL = true
        if (this.$refs.uploadDialog && this.$refs.uploadDialog.minDialog) {
          this.$refs.uploadDialog.minDialog = false
          this.$refs.uploadDialog.hasCancel = false
        }
      })
      await this.authUpload(this.param, e.target.files)
    },
    clearFileInput() {
      this.$refs.uploadit.value = ''
    },
    closed() {
      this.showConfirm = false
    },
    /**
       * 上传前的权限验证
       */
    async authUpload(paramter, file) {
      // 为了解决切换目录 上传路径不对的问题
      const param = paramter
      this.originPath = this.path
      param.prefix_neid = this.prefixNeid
      const files = file
      // 文件数量的校验
      if (files.length > 1000) {
        this.content = this.$t('对不起，一次最多只能添加1000个文件！')
        this.showConfirm = true
        this.clearFileInput()
        return
      }
      this.fileListLen += files.length
      let neid = ''
      if (this.isInitaiateApprove === true) {
        neid = store.state.selectedData.data[0].data.neid
      } else {
        neid = this.currentData.neid
      }
      if (this.isApprove === true) {
        if (this.taskId === '') {
          await postData('createUploadTask', {
            neid,
            nsid: this.currentData.nsid,
          }).then((res) => {
            this.approvefrom = res.data.from
            this.neid = res.data.snapshot_neid
            this.taskId = res.data.task_id
            this.param.from = res.data.from
            this.param.prefix_neid = res.data.snapshot_neid
            this.prefix_neid = res.data.snapshot_neid
          })
        }
      } else {
        this.approvefrom = this.currentData.from
        this.neid = this.currentData.neid
        this.param.from = this.currentData.from
        this.param.prefix_neid = this.currentData.prefix_neid
        this.taskId = ''
        this.prefix_neid = ''
      }
      // 格式化数据
      for (let x = 0, len = files.length; x < len; x += 1) {
        const data = {
          nsid: this.currentData.nsid || 1,
          from: this.approvefrom,
          neid: this.neid,
          path: this.path,
          // path_type: this.isApprove ? 'ent' : this.pathType,
          bytes: files[x].size,
          filename: files[x].name,
          language: param.language,
          'X-LENOVO-SESS-ID': Cookie.get('X-LENOVO-SESS-ID'),
          prefix_neid: param.prefix_neid || '',
          url: this.path,
        }

        const fileType = file[x].name.split('.').pop()
        // const fileLimit = store.state.lenovoData.fileLimit !== false ? store.state.lenovoData.fileLimit.split('.') : []
        // if (store.state.lenovoData.entFileLimit === 'true' && data.path_type === 'ent' && fileLimit.indexOf(fileType) > -1) {
        //   files[x].warnTxt = '文件类型不符合格式要求'
        //   this.lockList.push(x)
        // }
        //
        // if (store.state.lenovoData.selfFileLimit === 'true' && c.path_type === 'self' && fileLimit.indexOf(fileType) > -1) {
        //   files[x].warnTxt = '文件类型不符合格式要求'
        //   this.lockList.push(x)
        // }

        if (files[x].size > 5368709120) {
          files[x].warnTxt = '文件大于5G，请使用客户端上传'
          this.lockList.push(x)
        }
        if (files[x].name[0] === '.') {
          this.lockList.push(x)
          files[x].warnTxt = '文件名称不能以.开头'
        }

        // 当前目录没有上传权限，给提示
        const accessMode = this.currentData.access_mode
        if (accessMode) {
          if (accessMode.indexOf('upload') === -1) {
            this.$emit('showTips', '当前目录您没有上传权限')
            return
          }
        }

        this.totalSize += files[x].size

        const startTime = new Date().getTime()// 当前上传动作开始时间
        //
        let rootPath = ''
        let o = ''
        // if (this.$route.name === 'myapproval') {
        //   rootPath = '/企业空间'
        //   o = {
        //     data,
        //     file: files[x],
        //     startTime,
        //     path: rootPath + this.approvePath,
        //     neid: this.param.neid,
        //     path_type: 'ent',
        //     status: files[x].warnTxt !== undefined ? 'FAILED' : 'TOBEUPLOAD',
        //   }
        // } else {
        //
        // }
        // rootPath = this.currentData.path_type === 'ent' ? `/${this.getEntName}` : `/${this.$t('个人文件')}`
        o = {
          data,
          param: this.param,
          file: files[x],
          startTime,
          path: this.path,
          neid: this.currentData.neid,
          status: files[x].warnTxt !== undefined ? 'FAILED' : 'TOBEUPLOAD',
        }

        // o = JSON.parse(JSON.stringify(o));
        this.fileList.push(o)
        this.uploadInfo.splice(0, 1, this.fileList)
      }
      this.getUploadAuth()
    },
    getUploadAuth() {
      const file = this.uploadInfo[0][this.dataId]
      const urlTail = `${Util.encodePath(`${this.originPath}/${file.file.name}`)}`
      const relativePath = urlTail.split('/')
      relativePath.shift()
      relativePath.shift()
      const param = {
        bytes: file.data.bytes,
        file_type: `.${file.data.filename.split('.').slice(-1)}`,
        url: `/${this.currentData.delivery_code}`,
        relative_path: `/${decodeURIComponent(relativePath.join('/'))}`,
      }
      if (this.isProtected) {
        const tokenRes = JSON.parse(localStorage.getItem(`linkToken${this.currentData.delivery_code}`))
        param.url += `?token=${tokenRes.token}`
      }
      if (file.status === 'TOBEUPLOAD') {
        getData('getAuth', param).then((res) => {
          if (!res || !res.data || !res.data.region) return
          file.host = res.data.region// 返回的上传服务器地址
          this.afterCheckAuth()
        }).catch((error) => {
          if (error && error.response.data && error.response.data.message) {
            const err = error.response.data
            file.file.warnTxt = err.message
            file.error = true
            file.status = 'FAILED'
            this.$set(this.uploadInfo[0], this.dataId, file)
            this.afterCheckAuth()
          }
          this.lockList.push(this.dataId)
          if (this.dataId < this.uploadInfo[0].length - 1) {
            this.dataId += 1
            this.getUploadAuth()
          }
        })
      } else if (file.status === 'UPLOADING') {
        return false
      } else if (this.dataId < this.uploadInfo[0].length - 1) {
        this.dataId += 1
        this.getUploadAuth()
      } else {
        this.completeUpload()
      }
    },
    afterCheckAuth() {
      this.uploadFile(this.dataId)// 上传文件
    },
    dndUpload(params, dataTransferItems) {
      const files = params
      const self = this
      const h = this.$createElement
      if (this.folderDcType === 4) {
        this.$emit('showTips', this.$t('在该目录下没有上传权限'), 'error')
        return
      }
      if (files.length === 0) {
        const tips = this.$t('不支持上传文件夹，请用') + this.$t('PC客户端')
        this.$emit('showTips', tips, 'error')
        return
      }
      if (files.length > 1000) {
        this.$emit('showTips', this.$t('对不起，一次最多只能添加1000个文件！'))
        return
      }
      if (Util.BrowserType() === 'IE11' && files.length > 200) {
        this.$emit('showTips', this.$t('对不起，一次最多只能添加200个文件！'))
        return
      }
      if (dataTransferItems) {
        for (const dataTransferItem of dataTransferItems) {
          if (dataTransferItem.webkitGetAsEntry().isDirectory) {
            const tips = this.$t('不支持上传文件夹，请用') + this.$t('PC客户端')
            this.$emit('showTips', tips, 'error')
            return
          }
        }
      }
      for (const file of files) {
        const tempFile = this.validFile(file)
        if (tempFile.warnTxt !== undefined) {
          file.warnTxt = tempFile
        }
      }
      this.authUpload(this.param, files)
    },
    /**
       * 上传文件
       */
    uploadFile(asyncCount) { // @asyncCount 上传请求最大并发数
      const fileData = new FormData()
      const index = asyncCount || this.fileIndex
      const currentFileInfo = this.fileList[index]
      if (!currentFileInfo) return

      fileData.append('file', currentFileInfo.file)

      if (this.isApprove) {
        this.isSHowApprove = true
      }
      this.showUploadEL = true

      if (this.lockList.indexOf(index) > -1) {
        this.fileList[index].file.error = true
        this.uploadInfo.splice(0, 1, this.fileList)
        return
      }
      // 拼接URL
      let urlTail = ''
      if (this.isApprove) {
        urlTail = `${Util.encodePath(`/${currentFileInfo.file.name}`)}?`
      } else {
        urlTail = `${Util.encodePath(`${this.originPath}/${currentFileInfo.file.name}`)}?`
      }
      if (this.isProtected) {
        const tokenRes = JSON.parse(localStorage.getItem(`linkToken${this.currentData.delivery_code}`))
        this.$set(this.param, 'token', tokenRes.token)
      }
      this.$set(this.param, 'uid', this.uid)
      this.$set(this.param, 'account_id', this.accountId)
      // this.param.path_type = this.isApprove ? 'share_in' : currentFileInfo.path_type
      // this.param.prefix_neid = this.isApprove ? this.prefix_neid : currentFileInfo.data.prefix_neid
      for (const val of Object.keys(this.param)) {
        urlTail += `${val}=${this.param[val]}&`
      }
      urlTail = urlTail.slice(0, urlTail.length - 1)
      if (currentFileInfo.host) {
        // 将所执行的上传操作存到一个数组里
        const o = this.uploadAction(currentFileInfo.host,
          index, fileData, urlTail, currentFileInfo.file, currentFileInfo.startTime)
        this.fileList[index].axios = o
        this.$set(this.uploadInfo[0], index, this.fileList[index])
      } else {
        currentFileInfo.warnTxt = '文件大于5G，请使用客户端上传'
        this.lockList.push(index)
      }
    },
    validFile(params) {
      const file = params
      if (file.size > 1073741824 && Util.BrowserType() === 'IE11') {
        file.warnTxt = '文件大于1G，请使用客户端上传'
      } else if (file.size > 2147483648 && Util.BrowserType() === 'Edge') {
        file.warnTxt = '文件大于2G，请使用客户端上传'
      } else if (file.size > 5368709120) {
        file.warnTxt = '文件大于5G，请使用客户端上传'
      }
      if (file.name[0] === '.') {
        file.warnTxt = '文件名称不能以.开头'
      }
      return file
    },
    /**
     * 上传操作，以及上传的进度
     */
    uploadAction(host, index, fileData, urlTail, file, startTime) {
      const progress = (progressEvent) => {
        const currentTime = new Date().getTime()
        let speed = (progressEvent.loaded / 1024) / ((currentTime - startTime) / 1000)
        let { loaded } = progressEvent
        let remainInfo = { speed, loaded } // 当前剩余量
        if (progressEvent.loaded === progressEvent.total) {
          // 存入缓存
          this.tempFileList[index] = { ...this.tempFileList[index], progressEvent }
          this.tempFileList[index] = { ...this.tempFileList[index], remaining: remainInfo }
          // 存入当前执行条目信息 设置假的loaded 为总量-100
          const tempProgressEvent = Object.assign(progressEvent, {})
          // 计算当前速度,单位(KB/S)
          speed = (tempProgressEvent.loaded / 1024) / ((currentTime - startTime) / 1000)
          // 当前剩余量
          loaded = tempProgressEvent.loaded - 100
          remainInfo = { speed, loaded }
          this.fileList[index] = { ...this.fileList[index], tempProgressEvent }
          this.fileList[index] = { ...this.fileList[index], remaining: remainInfo }
          this.uploadInfo.splice(0, 1, this.fileList)
        } else {
          // 存入当前执行条目信息
          this.fileList[index] = { ...this.fileList[index], progressEvent }
          this.fileList[index] = { ...this.fileList[index], remaining: remainInfo }
          this.uploadInfo.splice(0, 1, this.fileList)
        }
      }
      const vm = this
      const temp = this.fileList[index]
      const fn = upload(host, urlTail, fileData, progress)
      temp.status = 'UPLOADING'
      this.$set(this.uploadInfo[0], index, temp)
      const actionList = fn.action.then((res) => {
        if (res.status === 200) {
          // 存入当前执行条目信息
          this.fileList[index] = {
            ...this.fileList[index],
            progressEvent: this.tempFileList[index].progressEvent,
          }
          this.fileList[index] = {
            ...this.fileList[index],
            remaining: this.tempFileList[index].remaining,
            status: 'SUCCESSED',
          }
          this.$set(this.uploadInfo[0], index, this.fileList[index])
          vm.afterUpload()
        }
      }).catch((error) => {
        const fileinfo = vm.uploadInfo[0][this.dataId]
        if (error.toString().indexOf('Network Error') > -1 || error.toString().indexOf('Request failed') > -1) {
          if (fileinfo.status !== 'CANCELED') {
            fileinfo.file.warnTxt = '网络连接异常，上传失败'
          }
        } else if (error.response && error.response.data) {
          fileinfo.file.warnTxt = error.response.data.message || '网络连接异常，上传失败'
        } else {
          return false
        }
        if (fileinfo.status !== 'CANCELED') {
          fileinfo.status = 'FAILED'
        }
        vm.$set(vm.uploadInfo[0], this.dataId, fileinfo)
        vm.afterUpload()
      })
      return { actionList, source: fn.source }
    },
    afterUpload() {
      if (this.dataId < this.uploadInfo[0].length - 1) {
        this.dataId += 1
        this.getUploadAuth()
      } else {
        this.getUploadAuth()
        this.clearFileInput()
      }
      this.completeUpload()
    },
    resultFormat(result) { // 格式化计算好的剩余时间
      const h = parseInt(((result / 60) / 60) % 24, 10)
      const m = parseInt((result / 60) % 60, 10)
      const s = result - h * 60 * 60 - m * 60
      if (result < 60) {
        return `${result}s`
      } if (h < 1) {
        return `${m}m${s}s`
      }
      return `${h}h${m}m${s}s`
    },
    cancelUpload(index) {
      if (index === 'all') {
        for (let x = 0; x < this.uploadInfo[0].length; x += 1) {
          const temp = this.uploadInfo[0][x]
          if (temp.status === 'TOBEUPLOAD' || temp.status === 'UPLOADING') {
            temp.status = 'CANCELED'
            if (temp.axios && temp.axios.source) {
              temp.axios.source.cancel(x)
            }
          }
          this.$set(this.uploadInfo[0], x, temp)
        }
        this.completeUpload()
      } else {
        const temp = this.uploadInfo[0][index]
        if (temp.status === 'TOBEUPLOAD' || temp.status === 'UPLOADING') {
          temp.status = 'CANCELED'
          if (temp.axios && temp.axios.source) {
            temp.axios.source.cancel(index)
          }
          this.$set(this.uploadInfo[0], index, temp)
          this.getUploadAuth()
        }
      }
      this.clearFileInput()
    },
    uploadListStatus() {
      let status = true
      this.uploadInfo[0].forEach((v) => {
        if (v.status === 'TOBEUPLOAD' || v.status === 'UPLOADING') {
          status = false
        }
      })
      return status
    },
    closeUploadEL() {
      if (this.uploadListStatus() === false) {
        const MsgBox = MessageBox
        Vue.prototype.$msgbox = MsgBox
        this.$msgbox(this.$t('确认取消所有未完成的任务？'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          showCancelButton: true,
          type: 'warning',
        }).then(() => {
          this.cancelUpload('all')
          this.toCloseUploadEl = false
          this.showUploadEL = false
          this.isSHowApprove = false
          this.clearData()
        }).catch(() => {
        })
      } else {
        this.toCloseUploadEl = false
        this.showUploadEL = false
        this.isSHowApprove = false
        this.uploadInfo[0] = []
        this.clearData()
      }
    },
    completeUpload() {
      // 审批情况下上传完毕之后弹窗不最小化
      if (!this.isApprove && this.uploadListStatus()) {
        if (this.$refs.uploadDialog) {
          this.$refs.uploadDialog.minDialog = true
        }
      }
      const vm = this
      // 在非上传文件对应的上传空间上传完毕后不刷新列表
      if (this.uploadInfo[0][this.dataId]
        && this.uploadInfo[0][this.dataId].data.path === vm.path && this.canRefresh) {
        this.canRefresh = false
        const timer = setTimeout(() => {
          clearTimeout(timer)
          this.canRefresh = true
          vm.$emit('refreshList', { refresh: true, url: vm.path })
        }, 500)
      }
    },
  },
}
</script>
<style lang='less'>
  .upload{
    display: inline-block;
    #isUploadBtn{
      min-width: 80px;
      border: 1px solid #c1c7cd;
      background: #fff;
      margin: 0 12px 0 0;
      padding: 0 12px;
      border-radius: 2px;
      font-size: 14px;
      height: 32px;
      text-align: center;
      line-height: 31px;
      box-sizing: border-box;
      cursor: pointer;
      display: inline-block;
      &:hover{
        background: #e7f0ff;
        border: 1px solid #3b83fb;
        color: #3b83fb;
      }
    }
  }
.approve-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 29;
  width: 100%;
  height: 100%;
  margin: 0;
  background: rgba(0, 0, 0, .4);
}
.approve-confirm, .approve-tips {
  .lv-btn {
    padding: 0;
    height: 32px;
    min-width: 80px;
    line-height: 30px;
  }

  .content-wraper{
    width: 422px;
  }

  .dialogUploadTips {
    position: relative;
    top: -32px;
    padding: 0 26px;
  }

  .uploadTipsNum {
    background-color: #8BDCF7;
    width: 24px;
    height: 24px;
    line-height: 24px;
    margin: 0 0 0 26px !important;
    border-radius: 13px;
    color: white;
    text-align: center;
    font-size: 13px;
  }

  .uploadTipsUl p {
    display: inline-block;
  }

  .uploadTipsTxt {
    margin: 0 0 0 12px !important;
    font-size: 14px;
  }

  .uploadTipsPoint {
    border-left: 1px solid #8BDCF7;
    height: 20px;
    margin-left: 38px;
    display: inline-block;
    margin-top: 3px;
  }

  .uploadTipsUl {
    list-style: none;
    padding: 0 0 20px 0;
    margin: 0;

    .title, .el-message-box__header {
      padding: 0 24px 20px 24px;
    }
  }

  .cleaning-switch {
    position: absolute;
    bottom: 30px;
    left: 26px;
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color:hsl(220, 3%, 39%);
    }
  }
  .el-message-box__title {
    span{
      font-size: 16px;
    }
  }

  .el-message-box__content{
    color: #1b2733;
    padding: 10px 0px;
  }

  .el-message-box__headerbtn{
    top: 20px;
    right: 24px;
    color: #929ca9;
    width: 24px;
    height: 24px;
    .el-message-box__close{
      font-size: 18px;
      color: #909399;
      font-weight: bold;
    }
    &:hover {
      background-color: #e8ebef;
      border-radius: 50%;
      width: 24px;
      height: 24px;

    }
  }

  .el-message-box__btns{
    padding: 24px 24px 14px 24px;
  }

  .el-message-box__header{
    padding: 24px;
  }

  .no-remind-drop {
    position: absolute !important;
    bottom: -61px;
    left: 24px;
  }

  .el-button {
    background: #3b83fb;
    border-color: #3b83fb;
    &:hover {
      background: #3b83fb;
      border-color: #3b83fb;
    }
  }
}


</style>
